import React from 'react';

import { UpdateFilterArgs, UseAdvancedFiltersProps } from '../hooks/useAdvancedFilters';

interface AdvancedFiltersContextType {
  clear: () => void;
  value: NonNullable<UseAdvancedFiltersProps['value']>;
  updateFilterValue: (args: UpdateFilterArgs) => void;
  prefix: string;
  drafts: { [key: string]: unknown };
}

export default React.createContext<AdvancedFiltersContextType>({
  clear: () => {},
  value: {},
  updateFilterValue: () => {},
  prefix: '',
  drafts: {},
});
